import { Button, Grid, Link, Typography } from "@mui/material";
import React from "react";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";

const ExeptionPage = ({ resetErrorBoundary }: any) => {
  return (
    <>
      <Grid
        container
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
        height={"100vh"}
        gap={"20px"}
      >
        <Grid item>
          <ReportGmailerrorredIcon style={{ fontSize: "80px" }} />
        </Grid>
        <Grid item>
          <Typography fontSize={"24px"} marginBottom={"10px"}>
            متاسفانه مشکلی بوجود آمده!
          </Typography>
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            color="primary"
            size="large"
            sx={{ borderRadius: "12px", paddingX: "24px", cursor: "pointer" }}
            onClick={() => {
              // resetErrorBoundary();
              window.location.href = "/";
            }}
          >
            بازگشت به سامانه
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default ExeptionPage;
